import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery } from '@/types/crud'

export interface ChannelCustomerFilters {
  sourceLabel: string
  thirdParty: string
  timeSlot: string[] | null
}

export interface ChannelCustomerRecord {
  corpName: string
  empId: string
  joinDate: string
  sourceLabel: string
  thirdParty: string
  unionId: string
}

export function fetchThirdParties(signal: AbortSignal) {
  return requestV2.get<string[]>({
    url: '/main/customerChannel/queryThirdPartyByCondition',
    params: { channelType: 'DRAINAGE' },
    signal
  })
}

export function fetchChannelSources(thirdParty: string, signal: AbortSignal) {
  return requestV2.get<string[]>({
    url: '/main/customerChannel/queryChannelByThirdParty',
    params: { thirdParty, channelType: 'DRAINAGE' },
    signal
  })
}

export async function fetchChannelCustomerPage(
  query: PageQuery<ChannelCustomerFilters>,
  signal: AbortSignal
) {
  const { sourceLabel, thirdParty, timeSlot } = query.filters
  const data = await requestV2.get<unknown>({
    url: '/main/channelCustomer/queryByCondition',
    params: {
      pageNo: query.pageNo,
      pageSize: query.pageSize,
      sourceLabel,
      thirdParty,
      timeSlot: timeSlot?.length ? timeSlot : undefined
    },
    signal
  })
  return normalizePageResult<ChannelCustomerRecord>(data)
}
